import ClientOAuth2 from 'client-oauth2'

let clientAuth = new ClientOAuth2({
	clientId: process.env.VUE_APP_CLIENT_ID,
	authorizationUri: process.env.VUE_APP_NODE_AUTHORIZATION_URI,
	redirectUri: process.env.VUE_APP_NODE_AUTHORIZATION_REDIRECT_URI
})

export function loginDocuId () {
	let pathname = new URL(location.href).pathname
	let ref = '&ref=' + encodeURI(pathname)
	location.href = clientAuth.token.getUri() + ref
}
